import type { FaireProductEntity } from "../../entity_types/product";

export const p_jxkvdyd9zp: FaireProductEntity = {
  token: "p_jxkvdyd9zp",
  type: "product",
  name: "Bee Market Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/52152b921ebd388cd59ab0174d1e1d53c6c7133dea978626c58b33ef522a5964.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0bcff783c4de0d80c69fd7fe3b8a22bda8b9faf0fde990d2c4e73c4b5fb7389.jpeg",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:55.971Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
